export default __webpack_public_path__ + "static/media/logosmalllovers.2c2c5d9d.png";